import { combineReducers } from "redux";
import productReducer from "./products";
import { wishListReducer } from "./wishList";
import compareListReducer from "./compare";
import cartReducer from "./cart";

// 🧾 Define the Root Reducer
const rootReducer = combineReducers({
  data: productReducer,
  cartList: cartReducer,
  wishList: wishListReducer,
  compareList: compareListReducer,
});

// 🧠 Export RootState type for useSelector
export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
